export { default as amenityDisplayNameMap } from './amenityDisplayNameMap';
export { default as Config } from './Config';
export { default as formatDistance, getPreferredLengthUnitForLocale } from './formattedDistance';
export { default as IconMap } from './iconMap';
export { default as logger } from './logger';
export type { Currency } from './Money';
export {
  MoneyUtil,
  Currencies,
  ConversionSupportedCurrencyCodesWithCurrencyNameAndSymbol,
  CurrencyCodesWithCurrencyNames,
  PreferredCurrencySymbol,
} from './Money';
export { createError } from './createError';
export * from './env';
export * from './Flights/index';
export * from './Flights/Cancel';
export * from './Flights/getRequiredFlightUrlSearchParams';
export * from './Flights/getRailSegmentsFromAirSegments';
export * from './Rail/getRailFareBreakup';
export * from './Rail/getOutOfPolicyRailPolicyRules';
export * from './Rail/isOutOfPolicyRailPolicy';
export * from './Rail/isDownloadWarningApplicable';
export * from './Rail/getIsAmtrakLeg';
export { default as getIsSplitTicket } from './Rail/getIsSplitTicket';
export { default as getIsGroupSave } from './Rail/getIsGroupSave';
export * from './Rail/getRailJourneyConfirmationDetails';
export * from './Rail/getRailBookingAreaFromSourceRefInfos';
export * from './Rail/getRailBookingAreaFromLegInfos';
export * from './Rail/getSeatPreferencesGroupInitialState';
export * from './Rail/getAirSegmentsFromRailSegments';
export * from './hotels';
export * from './useImmer';
export * from './timeZones';
export * from './auth';
export * from './Profile';
export * from './admin';
export * from './loyalty';
export * from './common';
export * from './vgsForm';
export * from './checkout';
export * from './convertDistance';
export * from './fareBreakupUtils';
export { default as getLayoverInfo } from './Flights/getLayoverInfo';
export { default as hasAirportChange } from './Flights/hasAirportChange';
export * from './trips';
export * from './tripStatus';
export * from './User';
export { default as delay } from './delay';
export * from './paymentMethods';
export * from './negotiatedFares';
export * from './corporateInfo';
export * from './feedback';
export * from './format/card';
export * from './customCard';
export * from './CustomFields';
export * from './getMobileTestId';
export * from './policies';
export { default as getCSSVariable } from './getCSSVariable';
export * from './Flights/getSpecialAndOtherUtas';
export * from './Flights/getIsSpecialUtaPolicyTypeBenefit';
export * from './Flights/getNumberOfSpecialUtasOfTypeBenefit';
export * from './Flights/getIsSpecialUtaPolicy';
export * from './Hotel/getHotelFareDetails';
export * from './Hotel/getMedianRateAndCurrencyCode';
export * from './Hotel/getSpecificHotelSearchRequest';
export * from './Flights/fareBreakupUtils';
export * from './Flights/getFlightFareBreakup';
export * from './errors';
export * from './bookingImporter';
export * from './xSessionId';
export * from './formatBookingDeadline';
export * from './CheckoutFeatures/checkoutFeatures';
export { getCountryLanguageAndFlagMapper } from './getCountryLanguageAndFlag';
export * from './submitVgsForm';

export const copyToClipboard = (html: string): void => {
  const selection = document.getSelection();
  const el = document.createElement('div');
  el.className = 'emailItinerary';
  el.innerHTML = html;
  el.style.position = 'absolute';
  el.style.left = '-9999px';
  document.body.appendChild(el);
  if (selection) {
    const selected =
      selection.rangeCount > 0 // Check if there is any content selected previously
        ? selection.getRangeAt(0) // Store selection if found
        : false; // Mark as false to know no selection existed before

    const range = document.createRange();
    range.selectNode(el);
    selection.removeAllRanges();
    selection.addRange(range);
    document.execCommand('Copy');
    document.body.removeChild(el);
    if (selected) {
      // If a selection existed before copying
      selection.removeAllRanges(); // Unselect everything on the HTML document
      selection.addRange(selected); // Restore the original selection
    }
  }
};
